import React from 'react'

const HeadlineCards = () => {
  return (
    <div className="max-w-[1640px] mx-auto p-4 py-12 grid md:grid-cols-3 gap-6">
        {/* card */}
        <div className="relative rounded-xl">
            {/* overlay */}
            <div className="w-full h-full rounded-xl absolute text-white bg-black/50">
                <p className="font-bold text-2xl px-2 pt-4">Sun's Out BOGOS Out</p>
                <p className="px-2">Through 8/26</p>
                <button className="border-white bg-white text-black mx-2 absolute bottom-4">Order Now</button>
            </div>
            <img 
            className="max-h-[160px] md:max-h-[200px] w-full rounded-xl object-cover"
            src="https://images.pexels.com/photos/461198/pexels-photo-461198.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
             alt='' />
        </div>
        <div className="relative rounded-xl">
            {/* overlay */}
            <div className="w-full h-full rounded-xl absolute text-white bg-black/50">
                <p className="font-bold text-2xl px-2 pt-4">New Restuarents</p>
                <p className="px-2">Added Daily</p>
                <button className="border-white bg-white text-black mx-2 absolute bottom-4">Order Now</button>
            </div>
            <img 
            className="max-h-[160px] md:max-h-[200px] w-full rounded-xl object-cover"
            src="https://images.pexels.com/photos/699953/pexels-photo-699953.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
             alt='' />
        </div>
        <div className="relative rounded-xl">
            {/* overlay */}
            <div className="w-full h-full rounded-xl absolute text-white bg-black/50">
                <p className="font-bold text-2xl px-2 pt-4">We Deliver Desert Too</p>
                <p className="px-2">Tasty Treats</p>
                <button className="border-white bg-white text-black mx-2 absolute bottom-4">Order Now</button>
            </div>
            <img 
            className="max-h-[160px] md:max-h-[200px] w-full rounded-xl object-cover"
            src="https://images.pexels.com/photos/262959/pexels-photo-262959.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
             alt='' />
        </div>
    </div>
  )
}

export default HeadlineCards